// extracted by mini-css-extract-plugin
export default {"message":"NationalSocietyReportsTable_message__aMxWL","phoneNumber":"NationalSocietyReportsTable_phoneNumber__XcJNv"};